"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserExternalURIFeature = BrowserExternalURIFeature;
const web_consensus_1 = require("@branch-ts/web-consensus");
const notFound_1 = require("../../view/notFound");
function BrowserExternalURIFeature() {
    web_consensus_1.UIMechanism.setFallbackURIHandler((option) => {
        const uri = option.uri;
        let url;
        try {
            url = new URL(uri, globalThis.location?.href);
        }
        catch {
            return false;
        }
        const isSameOrigin = !!globalThis.location && url.origin === globalThis.location.origin;
        if (isSameOrigin) {
            return false;
        }
        const protocol = url.protocol.slice(0, -1);
        if (protocol === "http" || protocol === "https") {
            globalThis.open(url.toString(), "_blank", "noopener,noreferrer");
            return true;
        }
        const app = web_consensus_1.PuriAppMechanism.ensure({
            uri: uri,
        });
        if (!app) {
            const notFound = new notFound_1.NotFound();
            notFound.present.configure({
                uri,
            });
            const win = new web_consensus_1.WindowBehavior(notFound);
            win.setTitle("Destination unavailable");
            win.maximize();
            void win.show();
            return true;
        }
        const win = new web_consensus_1.WindowBehavior(app);
        win.maximize();
        void win.show();
        return true;
    });
}
